import { Directive, ElementRef, Output, HostListener, EventEmitter } from '@angular/core';

@Directive({
  selector: '[lhClickOutside]',
  standalone: true,
})
export class ClickOutsideDirective {
  @Output() readonly clickOutside: EventEmitter<void> = new EventEmitter<void>();

  constructor(private readonly ref: ElementRef) {}

  @HostListener('document:click', ['$event.target']) onClick(targetElement: HTMLElement): void {
    const clickedElement = this.ref.nativeElement as HTMLElement;
    if (!clickedElement.contains(targetElement)) {
      this.clickOutside.emit();
    }
  }

  @HostListener('window:blur') onBlur(): void {
    if (document.activeElement?.tagName === 'IFRAME') {
      this.clickOutside.emit();
    }
  }
}
